import { createIcon } from '@chakra-ui/icons';

export const Search2 = createIcon({
  displayName: 'Search2',
  viewBox: '0 0 16 17',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_938_7341)">
        <path
          d="M15.5 16L12.5 13"
          stroke="#BABABA"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 13C9.81371 13 12.5 10.3137 12.5 7C12.5 3.68629 9.81371 1 6.5 1C3.18629 1 0.5 3.68629 0.5 7C0.5 10.3137 3.18629 13 6.5 13Z"
          stroke="#BABABA"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_938_7341">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
